import { useAuth } from '../../contexts/AuthContext';

export default function LogoutButton() {
  const { logout, user } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
    } catch (err) {
      console.error('Error logging out:', err);
    }
  };

  if (!user) return null;

  return (
    <button
      className="sidebar-logout-btn"
      onClick={handleLogout}
      title={`Log out (${user.email})`}
    >
      <span aria-hidden="true">↩</span> Log out
    </button>
  );
}
